import { pathJoin } from 'src/reducers/routing/utils'

export const createRouteMapCreateRouteScheme = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
})
